import React, { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { ThemeProvider } from "./ThemeContext";
import {
	rememberPostLoginRedirect,
	takePostLoginRedirect,
} from "./authRedirect";
import { CallbackPage } from "./components/CallbackPage";
import { Dashboard } from "./components/Dashboard";
import { LoginPage } from "./components/LoginPage";

const LoadingPage = ({ message = "Loading..." }) => (
	<div className="min-h-screen flex items-center justify-center bg-[var(--color-bg-app)]">
		<div className="text-center">
			<div className="h-8 w-8 animate-spin rounded-full border-4 border-[var(--color-accent)] border-t-transparent mx-auto" />
			<p className="mt-4 text-[var(--color-text-secondary)]">{message}</p>
		</div>
	</div>
);

const DashboardRoute = () => {
	const { user, loading } = useAuth();
	const location = useLocation();

	useEffect(() => {
		if (!loading && !user) {
			rememberPostLoginRedirect(location);
		}
	}, [loading, location, user]);

	if (loading) return <LoadingPage />;
	if (!user) return <Navigate to="/login" replace />;
	return <Dashboard />;
};

const LoginRoute = () => {
	const { user, loading } = useAuth();
	const location = useLocation();
	const [redirectTo] = React.useState(() =>
		takePostLoginRedirect(`/${location.search}${location.hash}`),
	);

	if (loading) return <LoadingPage message="Checking login..." />;
	if (user) return <Navigate to={redirectTo} replace />;
	return <LoginPage />;
};

function App() {
	return (
		<ThemeProvider>
			<Routes>
				<Route path="/callback" element={<CallbackPage />} />
				<Route path="/" element={<DashboardRoute />} />
				<Route path="/login" element={<LoginRoute />} />
			</Routes>
		</ThemeProvider>
	);
}

export default App;
